/* eslint-disable react/prop-types */
import {
	Alert,
	Box,
	Button,
	Grid,
	Input,
	InputLabel,
	MenuItem,
	Select,
	Snackbar,
	Typography,
	TextField,
	Modal,
	IconButton,
	InputAdornment,
} from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import manageProfileIcon from '../../../../../assets/logos/manageProfileicon.png';

import profilePicture from '../../../../../assets/logos/profilePicture.png';

import React, { useState } from 'react';

import { Link } from 'react-router-dom';

import { styled } from '@mui/system';
import { addStaff } from '../../../../services/api/apiManager';
import CancelIcon from '@mui/icons-material/Cancel';

import * as Yup from 'yup';
import dayjs from 'dayjs';
import { Add, Call } from '@mui/icons-material';
import MaskedInput from 'react-text-mask';

const StyledFileInput = styled('input')({
	display: 'none', // Hide the input visually
});

const StyledTypography = styled(Typography)({
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: '300',
	color: '#726A6A',
	textDecoration: 'underline',
	cursor: 'pointer',
});
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 'min(900px, calc(100vw - 32px))',
	backgroundColor: 'white',
	border: '1px solid #dce8f5',
	borderRadius: '10px',
	boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
	outline: 'none',
};

const modalLabelSx = {
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 600,
	color: '#0b2450',
	mb: 0.7,
};

const modalFieldRootSx = {
	minHeight: '42px',
	borderRadius: '6px',
	fontFamily: 'Poppins',
	fontSize: '13px',
	color: '#0b2450',
	backgroundColor: '#fff',
	boxShadow: 'none',
	'& fieldset': {
		borderColor: '#d7e3f4',
	},
	'&:hover fieldset': {
		borderColor: '#b8c9df',
	},
	'&.Mui-focused fieldset': {
		borderColor: '#2f6edb',
	},
};

const modalMaskedInputStyle = {
	width: '100%',
	height: '42px',
	borderRadius: '6px',
	border: '1px solid #d7e3f4',
	padding: '10px 12px',
	boxSizing: 'border-box',
	outlineColor: '#2f6edb',
	fontFamily: 'Poppins',
	fontSize: '13px',
	color: '#0b2450',
	backgroundColor: '#fff',
};

const modalSelectMenuProps = {
	PaperProps: {
		sx: {
			mt: 0.5,
			borderRadius: '6px',
			boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
			'& .MuiMenuItem-root': {
				fontFamily: 'Poppins',
				fontSize: '13px',
				minHeight: '34px',
			},
		},
	},
};
function AddStaff({ openModal,
	setOpenModal,
	fetchStaff,
	openSanckbarFromChild, }) {
	const defaultTheme = createTheme();

	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [openSnackbarError, setOpenSnackbarError] = useState(false);
	const [emptyField, setEmptyFieldError] = useState(false);
	// Close Modal
	const handleCloseModal = () => {
		setOpenModal(false);
	};
	const schema = Yup.object().shape({
		Fname: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		Lname: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		Title: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Type should contain only alphabets'),

		City: Yup.string().matches(
			/^[a-zA-Z\s]+$/,
			'City Name should contain only alphabets'
		),
		State: Yup.string().matches(
			/^[a-zA-Z]+$/,
			'State Name should contain only alphabets without empty spaces'
		),
		Specialty: Yup.string().matches(/^[a-zA-Z\s]+$/, ' only alphabets'),
		Contact: Yup.string().matches(
			/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid '
		),
		NPI: Yup.string().matches(/^\d+$/, 'Numbers only '),
		Zip: Yup.string().matches(/^\d+$/, 'Numbers only '),
	});

	const [errors, setErrors] = useState({});
	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setStaff((prev) => ({
			...prev,
			[name]: value,
		}));

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '',
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message,
				}));
			});
	};

	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbar(false);
	};
	const handleSnackbaErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbarError(false);
	};
	const handleEmptyFieldError = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setEmptyFieldError(false);
	};
	const practice_id = localStorage.getItem('practice_id');
	const [staff, setStaff] = useState({
		practice_id: practice_id,
		Fname: '',
		Lname: '',
		DOB: '',
		Gender: '',
		Contact: '',
		Title: '',
		NPI: '',
		Email: '',
		Address: '',
		Specialty: '',
		City: '',
		State: '',
		Zip: '',
		Comments: '',
	});
	const addStaffData = async () => {
		try {
			if (
				!staff.Title ||
				!staff.Fname ||
				!staff.Lname ||
				!staff.Specialty ||
				!staff.NPI ||
				!staff.Gender ||
				!staff.Contact ||
				!staff.DOB ||
				!staff.Address ||
				!staff.City ||
				!staff.State ||
				!staff.Zip
			) {
				setEmptyFieldError(true);
				return;
			}
			await schema.validate(staff, { abortEarly: false });
			const response = await addStaff(staff);
			if (response?.status === 201) {
				handleCloseModal();
				await fetchStaff();
				openSanckbarFromChild({
					openBar: true,
					barColor: 'green',
					snakbarFor: 'staff',
				});
				setStaff(true);
				setOpenSnackbar(true);
			} else if (response?.status === 400) {
				setOpenSnackbarError(true);
				openSanckbarFromChild({
					openBar: true,
					barColor: 'red',
					snakbarFor: 'staff',
				});
			} else {
				setOpenSnackbarError(true);
				openSanckbarFromChild({
					openBar: true,
					barColor: 'red',
					snakbarFor: 'staff',
				});
			}
		} catch (error) {
			console.error('Error updating staff:', error);
		}
	};
	const [addPicture, setAddPicture] = useState(null);

	const handleFileInputChange = (event) => {
		const file = event.target.files[0];
		const reader = new FileReader();
		reader.onload = () => {
			setAddPicture(reader.result);
		};
		reader.readAsDataURL(file);
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			{/* Darks code Start from here  */}
			<Modal
				open={openModal}
				aria-labelledby="edit-modal-title"
				aria-describedby="edit-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
					'& .MuiInputLabel-root': modalLabelSx,
					'& .MuiTextField-root, & .MuiFormControl-root': {
						'& .MuiOutlinedInput-root': modalFieldRootSx,
						'& .MuiInputBase-input': {
							padding: '10px 12px',
						},
					},
				}}
			>
				<Box sx={style}>
					<Grid container lg={12} xs={12} md={12} sm={12}>
						<Grid
							item
							lg={12}
							xs={12}
							md={12}
							sm={12}
							xl={12}
							justifyContent="center"
						>
							<Box
								sx={{
									width: '100%',
									height: '60px',
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									px: 2,
									borderBottom: '1px solid #edf2f8',
								}}
							>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontSize: '20px',
										fontWeight: 700,
										color: '#111827',
									}}
								>
									Add Staff
								</Typography>
								<IconButton onClick={handleCloseModal} sx={{ color: '#475569' }}>
									<CancelIcon sx={{ fontSize: '22px' }} />
								</IconButton>
							</Box>
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2.2}
						sx={{ p: 2.4, maxHeight: 'calc(100vh - 180px)', overflow: 'auto' }}
					>
						<Grid item lg={4} xs={12} md={4} sm={6} sx={{ p: 0 }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Title<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Title == ''}
								name="Title"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Title}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Title && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Title}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={4} xs={12} md={4} sm={6} sx={{ p: 0 }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								First Name<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Fname == ''}
								name="Fname"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Fname}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Fname && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Fname}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={4} xs={12} md={4} sm={6} sx={{ p: 0 }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Last Name<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Lname == ''}
								name="Lname"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Lname}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Lname && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Lname}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={4} xs={12} md={4} sm={6} sx={{ p: 0 }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								DOB<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								name="DOB"
								size="small"
								fullWidth
								disableUnderline
								onChange={(e) =>
									setStaff((prev) => ({ ...prev, DOB: e.target.value }))
								}
								error={staff.DOB >= dayjs(new Date()).format('YYYY-MM-DD')}
								helperText={
									staff.DOB >= dayjs(new Date()).format('YYYY-MM-DD')
										? '*Please Add Accurate DOB'
										: ''
								}
								type="date"
								format="YYYY-MM-DD"
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
									border: `${emptyField && staff?.DOB == '' && '1px solid #d61b1b'}`,
								}}
							/>
						</Grid>
						<Grid item lg={4} xs={12} md={4} sm={6} sx={{ p: 0 }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Specialty<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Specialty == ''}
								name="Specialty"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Specialty}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Specialty && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Specialty}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={4} xs={12} md={4} sm={6} sx={{ p: 0 }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Gender<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<Select
								error={emptyField && staff?.Gender == ''}
								name="Gender"
								size="small"
								fullWidth
								displayEmpty
								value={staff?.Gender || ''}
								onChange={(e) =>
									setStaff((prev) => ({ ...prev, Gender: e.target.value }))
								}
								MenuProps={modalSelectMenuProps}
								renderValue={(selected) => {
									if (!selected) {
										return <span style={{ color: '#8b9ab0' }}>Select gender</span>;
									}
									return selected === 'M' ? 'Male' : 'Female';
								}}
								sx={{
									...modalFieldRootSx,
									'& .MuiSelect-select': {
										padding: '10px 12px',
									},
								}}
							>
								<MenuItem value="">Select gender</MenuItem>
								<MenuItem value={'M'}>Male</MenuItem>
								<MenuItem value={'F'}>Female</MenuItem>
							</Select>
						</Grid>
						<Grid item lg={6} xs={12} md={6} sm={6} sx={{ p: 0 }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								NPI<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.NPI == ''}
								name="NPI"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.NPI}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.NPI && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.NPI}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={6} xs={12} md={6} sm={6} sx={{ p: 0 }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Mobile<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<MaskedInput
								required
								value={staff?.Contact}
								onChange={handleInputChange}
								name="Contact"
								mask={[
									'(',
									/\d/,
									/\d/,
									/\d/,
									')',
									' ',
									/\d/,
									/\d/,
									/\d/,
									'-',
									/\d/,
									/\d/,
									/\d/,
									/\d/,
								]}
								style={{
									...modalMaskedInputStyle,
									border: `${emptyField && staff?.Contact == '' ? '1px solid #d61b1b' : '1.5px solid #DDE6F1'}`,
								}}
							/>
							{errors.Contact && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Contact}
								</div>
							)}{' '}
						</Grid>

						<Grid
							item
							lg={12}
							xs={12}
							md={12}
							sm={12}
							xl={12}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Address<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Address == ''}
								name="Address"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Address}
								onChange={(e) =>
									setStaff((prev) => ({ ...prev, Address: e.target.value }))
								}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								City<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.City == ''}
								name="City"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.City}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.City && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.City}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								State<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.State == ''}
								name="State"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.State}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.State && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.State}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								ZIP<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Zip == ''}
								name="Zip"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Zip}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Zip && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Zip}
								</div>
							)}{' '}
						</Grid>
						<Box
							width={'100%'}
							display={'flex'}
							justifyContent={'flex-end'}
							gap={1.5}
							sx={{ pt: 1 }}
						>
							<Button
								onClick={handleCloseModal}
								sx={{
									height: '40px',
									minWidth: 126,
									borderRadius: '6px',
									border: '1px solid #cfd8e6',
									color: '#2f4467',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
								}}
							>
								Cancel
							</Button>
							<Button
								disabled={staff.DOB >= dayjs(new Date()).format('YYYY-MM-DD')}
								startIcon={<Add />}
								sx={{
									height: '40px',
									minWidth: 142,
									borderRadius: '6px',
									backgroundColor: `${staff.DOB >= dayjs(new Date()).format('YYYY-MM-DD') ? '#cbd5e1' : '#2f6edb'}`,
									color: '#fff',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									boxShadow: `${staff.DOB >= dayjs(new Date()).format('YYYY-MM-DD') ? 'none' : '0 4px 10px rgba(47, 110, 219, 0.2)'}`,
									'&:hover': {
										backgroundColor: `${staff.DOB >= dayjs(new Date()).format('YYYY-MM-DD') ? '#cbd5e1' : '#245fc5'}`,
									},
								}}
								onClick={() => {
									addStaffData();
								}}
							>
								Add Staff
							</Button>
						</Box>
					</Grid>
				</Box>
			</Modal>
			{/* Darks code ends here */}

			{/* snack bar for Patient added successfully */}
			<Snackbar
				open={openSnackbar}
				autoHideDuration={2000}
				onClose={handleSnackbarClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbarClose}
					severity="success"
					sx={{
						backgroundColor: '#3EAE4D',
						fontSize: '15px',
						padding: '15px',
						color: 'white',
						'& .MuiAlert-icon': {
							color: 'white',
						},
					}}
				>
					New Staff Added Successfully
				</Alert>
			</Snackbar>
			{/* snack bar for 401 error  */}
			<Snackbar
				open={openSnackbarError}
				autoHideDuration={2000}
				onClose={handleSnackbaErrorClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbaErrorClose}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '17px',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white',
						},
					}}
				>
					Error
				</Alert>
			</Snackbar>

			{/* snack bar for empty field  */}

			<Snackbar
				open={emptyField}
				autoHideDuration={2000}
				onClose={handleEmptyFieldError}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleEmptyFieldError}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '14px',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white',
						},
					}}
				>
					Fill all the Fields
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default AddStaff;
